import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    delivery_methods: [],
    delivery_method: {},
    pagination: {},
    new_delivery_method: {},
    validate_form: {
      name: [
        { required: true, message: 'Name is required', trigger: 'blur' },
      ],
      shipper_id: [
        { required: true, message: 'Shipper is required', trigger: 'blur' },
      ],
      delivery_max_miles: [
        { required: false },
      ],
      delivery_init_miles: [
        { required: false },
      ],
      delivery_init_mile_cost: [
        { required: false },
      ],
      delivery_additional_mile_cost: [
        { required: false },
      ],
      free_delivery_max_miles: [
        { required: false },
      ],
      free_delivery_min_amount: [
        { required: false },
      ],
      default: [
        { type: 'boolean', required: false },
      ],
      status: [
        { type: 'boolean', required: false },
      ],
    },
  },
  actions,
  mutations,
  getters,
};
